import React, { useState, useEffect } from 'react'
import { ListGroup, Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Header from '../components/HeaderComponent'
import Footer from '../components/FooterComponent'
import Loading from '../components/LoadingComponent'

function HomeComponent(props) {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(false)
  }, [])
  return (
    <>
      {
        loading ? <Loading /> : (
          <Container>
            <Row>
              <Col md={{ span: 6, offset: 3 }}>
                <Header />
                <h3>Daftar Isi</h3>
                <ListGroup variant="flush">
                  {props.surah.map(s => (
                    <Link className="removeLinkStyle" to={s.surat_name.toLowerCase().replace(' ', '-').replace(`'`, '')} key={s.id}>
                      <ListGroup.Item className="ayat">
                        <span className="surah-list">{s.surat_name}</span>
                      </ListGroup.Item>
                    </Link>
                  ))}
                </ListGroup>
                <Footer />
              </Col>
            </Row>
          </Container>
        )
      }
    </>
  )
}

export default HomeComponent